module.exports = __webpack_public_path__ + "static/media/dnd-inactive.42980f10.svg";